import { difference } from 'lodash';
import logError from 'util/misc/log-error';
import * as pageNames from 'constants/page-names';

/**
 * Verify if all the pages needed to run this project were properly set in the backend route
 * @props {object} registry - router registry where all main application routes will get stored
 */
export default function validate(registry) {
    // we could have used Object.values here but IE sucks and the polyfill are not available yet here :(
    const pageNamesCollection = Object.keys(pageNames).reduce((acc, key) => acc.concat(pageNames[key]), []);
    const registryNames = Object.keys(registry);
    const diff = difference(pageNamesCollection, registryNames);

    if (diff.length) {
        logError(new Error(`Please make sure that all the main application routes have a "name", I couldn't find any route for the pages: "${ diff.join(', ') }"`));
        return false;
    }

    return true;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/router/validator.js